export { default } from './svg/dropdown-icon.svg';
